const variables = {
  profileTooltipZIndex: 7,
  userInfoWrapperZIndex: 6,
  userBgImageZIndex: 5,
  cardZIndex: 1,
};

export default variables;
